/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsChangePassword204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsChangePassword505Schema = z.any();

export const optionsChangePasswordMutationResponseSchema = z.lazy(() => optionsChangePassword204Schema);
